<h2>Fee Schedules</h2>
<hr />

<div class="row claim-header">
  <div class="col-md-12">
    <app-grid-wrapper #grid persistenceKey="feeScheduleList">
      <button class="btn btn-primary" (click)="addEntity()"><i class="fa fa-plus"></i> Add</button>
    </app-grid-wrapper>
  </div>
</div>
